import { gql } from "@apollo/client";
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"
import { local } from 'data/lib/local-json'

// gql mutations

export const EDIT_USER_BY_TOKEN = gql`
  mutation EditUserByToken(
    $currentPassword: String
    $name: String
    $token: String!
    $updatedPassword: String
  ) {
    editUserByToken(
      currentPassword: $currentPassword
      name: $name
      token: $token
      updatedPassword: $updatedPassword
    ) {
      id
    }
  }
`;

// private module logic //

export type ProfileData = {
  firstName: string
  lastName: string
  currentPassword: string
  updatedPassword: string
  confirmNewPw: string
}

export type Profile = {
  error: string | null
  data: ProfileData
}

const profile = local('auth.profile');

const initialState: Profile = {
  error: null,
  data: {
    firstName: profile ? profile.name.split(" ")[0] : "",
    lastName: profile ? profile.name.split(" ").slice(1).join(' ') : "",
    currentPassword: "",
    updatedPassword: "",
    confirmNewPw: ""
  }
}

const profileStream = new BehaviorSubject<Profile>(initialState)

function updateData(key:string, value:string|null):void {
  if (key === 'error'){
    profileStream.next({ data: profileStream.getValue().data, error: value })
  } else {
    const currentData = profileStream.getValue().data;
    let nextState = {...currentData};
    nextState[key] = value;
    profileStream.next({ data: nextState, error: null });
  }
}

// public module interface //

const profileService = {
  stream: () => profileStream.asObservable(),
  updateData: (key:string, value:string|null) => updateData(key, value),
  updateProfile: EDIT_USER_BY_TOKEN
}

export default profileService